module.exports = __webpack_public_path__ + "static/media/code.b1f87b86.svg";